"use client";

import type { ComponentProps } from "react";

import {
  HoverCard,
  HoverCardContent,
  HoverCardPortal,
} from "@/components/ui/hover-card";
import { cn } from "@/lib/utils";

export type InlineCitationCardProps = ComponentProps<typeof HoverCard>;

export const InlineCitationCard = (props: InlineCitationCardProps) => (
  <HoverCard openDelay={100} closeDelay={200} {...props} />
);

export type InlineCitationCardBodyProps = ComponentProps<"div">;

export const InlineCitationCardBody = ({
  className,
  ...props
}: InlineCitationCardBodyProps) => (
  <HoverCardPortal>
    <HoverCardContent
      className={cn(
        "z-50 w-80 overflow-hidden rounded-xl border-gpt-border bg-background p-0 shadow-[var(--gpt-shadow-card)]",
        className
      )}
      side="top"
      sideOffset={8}
      align="start"
      collisionPadding={16}
      {...props}
    />
  </HoverCardPortal>
);
